import React, { useState, useEffect } from 'react';
import { Card, Descriptions } from 'antd';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined, GlobalOutlined } from '@ant-design/icons';
import { companyAPI } from '../services/api';
import './Contact.css';

function Contact() {
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    loadCompanyInfo();
  }, []);

  const loadCompanyInfo = async () => {
    try {
      const res = await companyAPI.getInfo();
      setCompanyInfo(res.data);
    } catch (error) {
      console.error('加载公司信息失败');
    }
  };

  if (!companyInfo) {
    return <div className="loading-container">加载中...</div>;
  }

  const websiteUrl = companyInfo.website?.startsWith('http')
    ? companyInfo.website
    : `https://${companyInfo.website}`;
  const websiteText = companyInfo.domain || companyInfo.website?.replace(/^https?:\/\//, '');

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1 className="page-title">联系我们</h1>
        <p className="page-subtitle">我们随时为您提供专业的服务支持</p>
      </div>

      <Card className="contact-card">
        <Descriptions column={1} bordered size="large">
          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <EnvironmentOutlined /> 公司名称
              </span>
            }
          >
            {companyInfo.name}
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <PhoneOutlined /> 联系电话
              </span>
            }
          >
            <a href={`tel:${companyInfo.contact.phone}`} className="contact-link">
              {companyInfo.contact.phone}
            </a>
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <MailOutlined /> 电子邮箱
              </span>
            }
          >
            <a href={`mailto:${companyInfo.contact.email}`} className="contact-link">
              {companyInfo.contact.email}
            </a>
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <EnvironmentOutlined /> 公司地址
              </span>
            }
          >
            {companyInfo.contact.address}
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <GlobalOutlined /> 官方网站
              </span>
            }
          >
            <a href={websiteUrl} target="_blank" rel="noopener noreferrer" className="contact-link">
              {websiteText}
            </a>
          </Descriptions.Item>

          <Descriptions.Item
            label={
              <span className="label-with-icon">
                <GlobalOutlined /> ICP备案
              </span>
            }
          >
            {companyInfo.icp}
          </Descriptions.Item>
        </Descriptions>

        <div className="contact-hours">
          <h3>营业时间</h3>
          <p>周一至周五：9:00 - 18:00</p>
          <p>周末及节假日：10:00 - 17:00</p>
        </div>

        <div className="contact-note">
          <h3>温馨提示</h3>
          <ul>
            <li>如需紧急心理援助，请拨打24小时热线</li>
            <li>企业合作请发送邮件至企业服务邮箱</li>
            <li>产品咨询和售后服务请在工作时间联系</li>
          </ul>
        </div>
      </Card>
    </div>
  );
}

export default Contact;
